import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Checkbox } from './ui/checkbox';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SharePlanDialog = ({ isOpen, onClose, planId }) => {
  const [families, setFamilies] = useState([]);
  const [selectedFamilies, setSelectedFamilies] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchFamilies();
    }
  }, [isOpen]);

  const fetchFamilies = async () => {
    try {
      const response = await axios.get(`${API}/family/`);
      console.log('📊 Resposta de famílias:', response.data);
      const familiesList = response.data.families || [];
      console.log('👨‍👩‍👧 Famílias encontradas:', familiesList.length);
      setFamilies(familiesList);
      
      if (familiesList.length === 0) {
        toast.info('Você ainda não faz parte de nenhuma família');
      }
    } catch (error) {
      console.error('Error fetching families:', error);
      toast.error('Erro ao buscar famílias');
    }
  };

  const handleShare = async () => {
    if (!planId) {
      toast.error('Salve o plano primeiro para compartilhar');
      onClose();
      return;
    }
    
    if (selectedFamilies.length === 0) {
      toast.error('Selecione pelo menos uma família');
      return;
    }
    
    try {
      setLoading(true);
      console.log('📤 Compartilhando plano:', planId, 'com famílias:', selectedFamilies);
      
      await axios.post(`${API}/meal-plans/${planId}/share-family`, {
        family_ids: selectedFamilies
      });
      
      toast.success('Plano compartilhado com sucesso!');
      onClose();
    } catch (error) {
      console.error('Error sharing plan:', error);
      console.error('Detalhes do erro:', error.response?.data);
      toast.error(error.response?.data?.detail || 'Erro ao compartilhar plano');
    } finally {
      setLoading(false);
    }
  };

  const toggleFamily = (familyId) => {
    setSelectedFamilies(prev =>
      prev.includes(familyId)
        ? prev.filter(id => id !== familyId)
        : [...prev, familyId]
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Compartilhar Plano com Família</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {families.length === 0 ? (
            <p className="text-gray-500 text-center py-4">
              Você ainda não faz parte de nenhuma família.
              Crie ou entre em uma família para compartilhar planos!
            </p>
          ) : (
            families.map(family => (
              <div key={family.id} className="flex items-center space-x-3 p-3 border rounded-lg hover:bg-gray-50">
                <Checkbox
                  checked={selectedFamilies.includes(family.id)}
                  onCheckedChange={() => toggleFamily(family.id)}
                />
                <div>
                  <p className="font-medium">{family.name}</p>
                  <p className="text-xs text-gray-500">{family.member_count || 0} membros</p>
                </div>
              </div>
            ))
          )}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button 
            onClick={handleShare} 
            disabled={loading || selectedFamilies.length === 0}
            className="bg-orange-600 hover:bg-orange-700"
          >
            {loading ? 'Compartilhando...' : 'Compartilhar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SharePlanDialog;